'use client';
import Image from '@repo/ui/src/components/Image/New';
import { ToutContent } from '@repo/ui/src/components/ToutContent';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ToutContentProps } from '@repo/ui/src/types/toutContent';
import { ImageProps } from '@repo/ui/src/types/image';
import { classNames } from '@repo/ui/src/utils/classNames';

export interface RelatedGridProps {
  toutContent?: ToutContentProps;
  backgroundImage?: ImageProps;
  saleText?: string;
  newText?: string;
  _data?: Array<any>; // Raw product data from CMS
  productClicked?: (product: any, index: number, listName?: string) => void;
  locale?: string;
  store?: string;
  children?: any;
}

const gradientAlignments = {
  left: 'tw-bg-gradient-to-tl',
  right: 'tw-bg-gradient-to-tr',
};

const RelatedGrid = ({ toutContent, backgroundImage, children }: RelatedGridProps) => {
  const backgroundImageUrl = backgroundImage?.image ? buildImageSrc(backgroundImage, 400) : '';

  return (
    <div
      data-test-id={`related_product_grid_test`}
      className="tw-grid md:tw-grid-cols-[minmax(0,1fr),minmax(0,2fr)] lg:tw-grid-cols-[minmax(0,1fr),minmax(0,3fr)]"
    >
      <div className={backgroundImage ? 'tw-relative' : 'tw-bg-black'}>
        {backgroundImage && (
          <Image
            src={backgroundImageUrl}
            alt=""
            fill
            className="-tw-z-10 tw-absolute tw-object-cover tw-min-h-96"
          />
        )}
        <div
          className={classNames(
            'tw-h-full tw-min-h-[inherit] tw-from-transparent tw-to-[rgba(0,0,0,0.7)] tw-to-90% tw-from-0%',
            gradientAlignments[(toutContent?.align ?? '') as keyof typeof gradientAlignments] ??
              'tw-bg-gradient-to-t',
          )}
        >
          <ToutContent
            dark
            headingStyleVariant="h2"
            align={toutContent?.align ?? 'left'}
            {...toutContent}
            className="tw-p-6 sm:tw-p-gutterLG"
            forceDivider
          />
        </div>
      </div>
      <ul className="tw-list-none tw-grid sm:tw-grid-cols-2 lg:tw-grid-cols-3 tw-pl-0">
        {children}
      </ul>
    </div>
  );
};

export default RelatedGrid;
